import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { useMemo } from "react";

const CONTACT_CATEGORIES_BASE = "/ContactCategories";

const getContactCategoriesAPI = () =>
  API.get(`/contactcategories?orderby=categoryName`);

const addContactCategoryAPI = (data) =>
  API.post(`${CONTACT_CATEGORIES_BASE}`, data);

const updateContactCategoryAPI = (id, data) =>
  API.patch(`${CONTACT_CATEGORIES_BASE}/${id}`, data);

const getContactCategoryInfo = (categoryId) =>
  API.get(`${CONTACT_CATEGORIES_BASE}/${categoryId}`);

const getSuggestedContactCategories = (matterId) =>
  API.get(`/contactcategories/Suggested/${matterId}`);

const baseService = createApplicationService({
  name: "contactCategories",
  apiFetchFn: getContactCategoriesAPI,
  apiAddFn: addContactCategoryAPI,
  apiUpdateFn: updateContactCategoryAPI,
});

const contactCategoriesReducer = baseService.reducer;
const getContactCategories = baseService.getData;
const addContactCategory = baseService.addData;
const updateContactCategory = baseService.updateData;
const useContactCategories = baseService.useData;

const getActiveContactCategories = async () => {
  const categories = await getContactCategories();
  return categories.filter((c) => c.active) || [];
};

const useActiveContactCategories = () => {
  const { data, loading } = useContactCategories();
  const activeContactCategories = useMemo(
    () => data.filter((c) => c.active),
    [data],
  );
  return { data: activeContactCategories, loading };
};

export {
  contactCategoriesReducer,
  getContactCategories,
  getContactCategoryInfo,
  getSuggestedContactCategories,
  addContactCategory,
  updateContactCategory,
  getActiveContactCategories,
  useContactCategories,
  useActiveContactCategories,
};
